import { FormDocumentBase } from './form-document-base';

export class FormClinicDocument extends FormDocumentBase {

  clinicId: number;
  isRequiredForMedicalRecordRelease: boolean;

  constructor() {
    super();
    this.clinicId = 0;
    this.comment = '';
    this.fileDate = null;
    this.fileName = '';
    this.fileSizeBytes = 0;
    this.isRequiredForMedicalRecordRelease = false;
  }
}
